<template>
  <div>
    <receiving-close-table v-show="activeKey===1" ref="list" :orderStatus="orderStatus" @getDetail="getDetail"/>
    <receiving-close-detail v-show="activeKey===2" ref="detail" :dataSources="dataSources" :orderStatus="orderStatus" @back="back"/>
  </div>
</template>

<script>
import ReceivingCloseTable from '@/views/inbound/receiving_close/ReceivingCloseTable.vue'
import ReceivingCloseDetail from '@/views/inbound/receiving_close/ReceivingCloseDetail.vue'
import { getEnums } from '@/utils/util'

export default {
  name: 'ReceivingClose',
  components: { ReceivingCloseTable, ReceivingCloseDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      dataSources: []
    }
  },
  created() {
    getEnums('OrderStatus').then(result => {
      this.orderStatus = result
      return getEnums('DataSource')
    }).then(result => {
      this.dataSources = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.getDetail(row.asnOrder.id)
    }
  }
}
</script>